import React from "react";
import styles from "./style.module.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { PageViewer } from "../../../types/admin";
import { roleIcons, routeConfigs } from "../../../routes/routeConfigs";

export default function UsersByPageList() {
  const viewersByPage = useSelector(
    (state: RootState) => state.admin?.viewersByPage,
    isEqual,
  );

  const getIconForPage = (pageName: string) => {
    const routeConfig = Object.values(routeConfigs).find(
      (config) => config.name === pageName,
    );
    return routeConfig?.icon;
  };

  const getIconForRole = (role: string) => {
    return roleIcons[role as keyof typeof roleIcons] || null;
  };

  const getRouteOrder = (pageName: string) => {
    const routeIndex = Object.values(routeConfigs).findIndex(
      (config) => config.name === pageName,
    );
    return routeIndex === -1 ? 999 : routeIndex;
  };

  // Sort pages by their order in route configs
  const sortedPages = Object.entries(viewersByPage).sort(([pageA], [pageB]) => {
    return getRouteOrder(pageA) - getRouteOrder(pageB);
  });

  return (
    <div className={styles.container}>
      {sortedPages.map(([page, users]) => {
        const IconComponent = getIconForPage(page);
        return (
          <div key={page} className={styles.pageContainer}>
            <div className={styles.pageName}>
              {IconComponent && (
                <span className={styles.pageIcon}>
                  <IconComponent />
                </span>
              )}
              {page}
            </div>
            <div className={styles.usersList}>
              {users.map((user: PageViewer, idx: number) => {
                const RoleIcon = getIconForRole(user.role);
                return (
                  <div className={styles.userName} key={idx}>
                    {RoleIcon && (
                      <span className={styles.pageIcon}>
                        <RoleIcon />
                      </span>
                    )}
                    <span className={styles.userText}>
                      {user.user.toLowerCase()}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}
